export default __webpack_public_path__ + "static/icon-tile-color-light-ca9be6ae8fcab7f57c45612ba5512258.png";